import { Info } from 'lucide-react';
import { ReactNode } from 'react';
import { ResetButton } from './ResetButton';
import { FormControl, FormItem, FormLabel } from '@/Domain/components/Shared/Form/Form';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/Domain/components/Shared/Tooltip/Tooltip';

type Props = {
  label: string;
  testId: string;
  control: ReactNode;
  onReset: () => void;
  hint?: string;
  warning?: string;
};

export const ColorRow = ({ label, testId, control, onReset, hint, warning }: Props) => (
  <FormItem data-testid={testId} className="grid grid-cols-[1fr_auto] items-center gap-4 space-y-0">
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1.5">
        <FormLabel className="text-sm">{label}</FormLabel>
        {hint && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info
                  className="size-3.5 text-foreground-subtle cursor-help"
                  data-testid={`${testId}-hint`}
                />
              </TooltipTrigger>
              <TooltipContent className="max-w-xs">{hint}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      {warning && (
        <p className="text-xs text-warning-foreground" data-testid={`${testId}-warning`}>
          {warning}
        </p>
      )}
    </div>
    <div className="flex items-center gap-2">
      <FormControl>{control}</FormControl>
      <ResetButton onClick={onReset} testId={`${testId}-reset`} />
    </div>
  </FormItem>
);
